var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15.59 7.386a.833.833 0 0 1 0 1.178l-5 5a.833.833 0 0 1-1.18 0l-5-5a.833.833 0 0 1 1.18-1.178l4.41 4.41 4.41-4.41a.833.833 0 0 1 1.18 0",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDown;